/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateSignaturePadResponse } from '../../models/create-signature-pad-response';
import { KeyType } from '../../models/key-type';
import { PostConsignorSignaturePad } from '../../models/post-consignor-signature-pad';

export interface PostConsignorSignaturePad$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
      body: PostConsignorSignaturePad
}

export function postConsignorSignaturePad(http: HttpClient, rootUrl: string, params: PostConsignorSignaturePad$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateSignaturePadResponse>> {
  const rb = new RequestBuilder(rootUrl, postConsignorSignaturePad.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateSignaturePadResponse>;
    })
  );
}

postConsignorSignaturePad.PATH = '/organization-sites/{organizationSiteKey}/consignor/delivery-note-bundles/signature-pads/checkout';
